import { Routes } from "@/modules/router/components/Routes";
import { ServiceWorkerInitializer } from "@/modules/serviceWorker/ServiceWorkerInitializer";
import { PageMeta } from "@/modules/theme/components/PageMeta";

import { DownloadAppFromStoreDialog } from "./DownloadAppFromStoreDialog";
import { Providers } from "./Providers";

function App() {
  return (
    <Providers>
      <PageMeta />
      <Routes />
      {/* <ServiceWorkerInitializer /> should be always rendered */}
      {/* Otherwise service worker won't be registered!  */}
      <ServiceWorkerInitializer />
      <DownloadAppFromStoreDialog />
    </Providers>
  );
}

export default App;
